import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthContext';
import { homePathFor } from '../utils/homePath';

// The front door. Someone already signed in on this device goes straight to
// their own first screen; anyone else goes to the login form.
//
// "/" used to send everybody to the login form, signed in or not - and "/" is
// where the app opens from a phone's home screen, so every launch looked like
// being signed out, though the session was still there and good for 30 days.
//
//   children  what to show to someone who is not signed in. Without it, they
//             are sent to the login form.
const HomeRedirect = ({ children = null }) => {
    const { user, loading } = useAuth();

    // The stored session is read a moment after the first paint. Deciding
    // before that would send a signed-in user to the login form after all.
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    const home = user ? homePathFor(user.role) : null;
    if (home) return <Navigate to={home} replace />;

    return children || <Navigate to="/login" replace />;
};

export default HomeRedirect;
